import { Nav } from '@catalogo/core-nav';
import React from 'react';
import { errorsFeedback } from './errors-feedback';

export const formatErrorMessage = async (result, qnaFaqUrl) => {
  const validationErrors = await result?.data?.addQuestion?.validationErrors;
  const regExp = /\[.*?\]/gi;
  const tagBruta = validationErrors == undefined ? '' : regExp.exec(validationErrors[0]?.message);
  const tagErro = tagBruta != null ? tagBruta[0]?.replace('[', '').replace(']', '') : null;
  const status = result?.errors != undefined ? result.errors[0].extensions.status : null;

  const responses = {
    competidor: {
      title: 'essa pergunta parece ter conteúdo inadequado',
      message: `Revise sua pergunta e tente de novo :)`,
      status: true,
    },
    pejorativo: {
      title: 'essa pergunta parece ter conteúdo inadequado',
      message: `Revise sua pergunta e tente de novo :)`,
      status: true,
    },
    precoFrete: {
      title: 'esse espaço é para fazer perguntas sobre as características do produto, tá?',
      message: (
        <span>
          Sua dúvida não é sobre o produto? <Nav to={qnaFaqUrl}>Nossa FAQ</Nav> pode te ajudar :)
        </span>
      ),
      status: true,
    },
  };
  const responseApiErrors = {
    429: {
      statusCode: status,
      title: errorsFeedback.timeoutRuning,
      message: `Aguarde 60s pra perguntar de novo`,
      status: true,
    },
  };
  const responseDefault = {
    ...errorsFeedback['default'](),
    status: true,
  };

  return responses[tagErro] || responseApiErrors[status] || responseDefault;
};
